module.exports = __webpack_public_path__ + "static/media/gradient_p.e12b654c.png";